module["exports"] = [
  "#####",
  "### ##",
  "## ###"
];
